import { Subject } from 'rxjs';

export class SignMailEventBus {
  static recordingFinished$ = new Subject<void>();
}
